import Category, { getServerSideProps } from '../[...slug]'

export { getServerSideProps }
export default Category
